export default {
      Manufacturers: 'Manufacturer|Manufacturers',

};
